import apiClient from './client';

// 타임아웃 설정을 위한 인터페이스
interface ApiConfig {
  timeout?: number; // 밀리초 단위
  [key: string]: any; // 기타 axios 설정
}

// API 요청 헬퍼 함수들
export const api = {
  // GET 요청
  get: async (url: string, config?: ApiConfig) => {
    return await apiClient.get(url, config);
  },

  // POST 요청
  post: async (url: string, data?: any, config?: ApiConfig) => {
    return await apiClient.post(url, data, config);
  },

  // PUT 요청
  put: async (url: string, data?: any, config?: ApiConfig) => {
    return await apiClient.put(url, data, config);
  },

  // DELETE 요청
  delete: async (url: string, config?: ApiConfig) => {
    return await apiClient.delete(url, config);
  },

  // PATCH 요청
  patch: async (url: string, data?: any, config?: ApiConfig) => {
    return await apiClient.patch(url, data, config);
  },
};

// 사용 예시:
//
// // 기본 타임아웃 사용 (30초)
// const response1 = await api.get('/items/');
//
// // 커스텀 타임아웃 사용 (10초)
// const response2 = await api.post('/items/', data, { timeout: 10000 });
//
// // 긴 타임아웃 사용 (60초)
// const response3 = await api.get('/large-data/', { timeout: 60000 });

export default api;
